import React from 'react';
import { Gift, Star, DollarSign, Zap } from 'lucide-react';

const SignUpBanner = ({ onSignUpClick }) => {
  return (
    <div className="relative z-30 w-full bg-gradient-to-r from-purple-900/90 via-blue-900/90 to-purple-900/90 backdrop-blur-lg border-y border-purple-500/30 py-8 px-4 shadow-2xl">
      <div className="container mx-auto max-w-6xl">
        {/* Main Title */}
        <div className="text-center mb-6">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
            🎁 Create a Free Account & Get Rewards!
          </h3>
          <p className="text-purple-200 text-sm md:text-base">
            Join our community and unlock exclusive benefits
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          {/* Benefit 1 */}
          <div className="bg-black/40 backdrop-blur-sm rounded-lg p-4 border border-purple-500/20 hover:border-purple-500/50 transition-all">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mb-3">
                <Gift className="text-white" size={24} />
              </div>
              <h4 className="text-white font-bold text-sm mb-1">Get Your Referral Code</h4>
              <p className="text-purple-200 text-xs">Share with friends, you both save 20%</p>
            </div>
          </div>

          {/* Benefit 2 */}
          <div className="bg-black/40 backdrop-blur-sm rounded-lg p-4 border border-blue-500/20 hover:border-blue-500/50 transition-all">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mb-3">
                <Star className="text-white" size={24} />
              </div>
              <h4 className="text-white font-bold text-sm mb-1">Earn Loyalty Credits</h4>
              <p className="text-blue-200 text-xs">1 free credit for every 3 hours booked</p>
            </div>
          </div>

          {/* Benefit 3 */}
          <div className="bg-black/40 backdrop-blur-sm rounded-lg p-4 border border-green-500/20 hover:border-green-500/50 transition-all">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center mb-3">
                <DollarSign className="text-white" size={24} />
              </div>
              <h4 className="text-white font-bold text-sm mb-1">Exclusive Discounts</h4>
              <p className="text-green-200 text-xs">Access member-only special offers</p>
            </div>
          </div>

          {/* Benefit 4 */}
          <div className="bg-black/40 backdrop-blur-sm rounded-lg p-4 border border-yellow-500/20 hover:border-yellow-500/50 transition-all">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mb-3">
                <Zap className="text-white" size={24} />
              </div>
              <h4 className="text-white font-bold text-sm mb-1">Faster Booking</h4>
              <p className="text-yellow-200 text-xs">Save info & book in seconds</p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex flex-col items-center">
          <button
            onClick={onSignUpClick}
            className="px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 text-white rounded-full font-bold text-lg hover:from-purple-700 hover:via-pink-700 hover:to-purple-700 transition-all hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/50 animate-pulse"
          >
            🎉 Sign Up Free - Get Your Referral Code Now!
          </button>
          <p className="text-purple-300 text-xs mt-2">
            No credit card required • Takes 30 seconds • Start saving today
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpBanner;
